/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { type PropsWithChildren } from 'react';
import Box from '@atlaskit/primitives/box';
import { xcss } from '@atlaskit/primitives/xcss';
import { LoadingSpinner } from '../loading-spinner/index.tsx';

type MenuContainerProps = PropsWithChildren<{ isLocked: boolean }>;

export const MenuContainer = ({ children, isLocked }: MenuContainerProps): React.JSX.Element => (
	<Box xcss={[position, isLocked ? locked : undefined]}>
		{children}
		{isLocked && (
			// eslint-disable-next-line jira/integration/test-id-by-folder-structure
			<LoadingSpinner testId="navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.ui.menu-container.loading-spinner" />
		)}
	</Box>
);

const position = xcss({
	position: 'relative',
});

const locked = xcss({
	opacity: 0.5,
});
